module.exports = __webpack_public_path__ + "img/36_16.59fd01ca.png";